import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { t } from 'src/lib/language';
import SendIcon from '@material-ui/icons/Send';
import { openDialog } from 'src/redux/actions/dialogActions';
import { DIALOGS } from 'src/models/DialogModel';
import { AmbassadorInvitationPayload } from 'src/models/FundraisingModel';

interface OwnProps {
  payload: AmbassadorInvitationPayload,
  fundraisingId: string | number,
}

const SendInvoiceByEmailButton = (props: ButtonProps & OwnProps) => {
  const { disabled, payload, fundraisingId } = props;
  const dispatch = useAppDispatch();
  const lang = useSelector((state: Store) => state.language.language);

  const handleOnClick = () => {
    dispatch(openDialog({
      dialog: DIALOGS.sendAmbassadorInvitation,
      payload: {
        data: payload,
        fundraisingId,
      },
    }));
  };

  return (
    <>
      <Tooltip
        title={t(lang, 'menus.send_invoice_by_email')}
        placement="top-start">
        <span>
          <ActionButton
            variant="outlined"
            category={MENU_BUTTON_CATEGORY.download}
            onClick={handleOnClick}
            disabled={disabled}>
            <SendIcon />
          </ActionButton>
        </span>
      </Tooltip>
    </>
  );
};

export default SendInvoiceByEmailButton;
